import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
import useBottomSheet from 'hooks/common/useBottomSheet';
import { useEffect, useLayoutEffect, useState } from 'react';

const TimeBuffFilters = () => {
  const [selectedGender, setSelectedGender] = useState<'female' | 'male'>();
  const { close, sheets } = useBottomSheet();
  const sheet = sheets.TimeBuffFilter;

  useEffect(() => {
    setSelectedGender(myinfo.gender === 'male' ? 'female' : 'male');
  }, []);

  useLayoutEffect(() => {
    imagePreload();
  }, []);

  const handleClickFilter = (gender: string) => {
    if (gender === 'female' || gender === 'male') {
      setSelectedGender(gender);
    }
  };

  const swipe = async () => {
    try {
      if (!selectedGender) {
        return;
      }

      if (!TimeBuffManager.getIsTimeBuff()) {
        await TimeBuffManager.deduct();
      }
      MainUI.changePreferGender(selectedGender);
      close(sheet.id);
      Transition.moveTab(Def.TAB_HOME);
      FindUI.find();
    } catch (err) {
      // TO-DO: 에러 로그 보내기
      BLog.err(err);
    }
  };

  useEffect(() => {
    if (LiteDataManager.getState() > 0) {
      const hMainContainer = document.getElementById('hMainContainer');
      if (hMainContainer) {
        CommonUI.showToast(hMainContainer, { text: brsc.time_buff_toast_1, duration: 2000, position: 'bottom' });
      }
    }
  }, []);

  function imagePreload() {
    const sources = [
      '/imgweb/sale/infinity_silver.png',
      '/imgweb/sale/time_buff_female_active.svg',
      '/imgweb/sale/time_buff_female_inactive.svg',
      '/imgweb/sale/time_buff_male_active.svg',
      '/imgweb/sale/time_buff_male_inactive.svg',
    ];

    sources.forEach((src) => {
      const image = new Image();
      image.src = src;
    });
  }

  return (
    <div className="flex h-full w-full flex-col items-center">
      {!TimeBuffManager.getIsTimeBuff() && <TimeBuffInfo />}
      <div id="hTimeFilterCountDown" className="mb-4 typography-title-md"></div>
      <div className="mb-4 typography-headline-lg">{brsc.gender_please}</div>
      <div className="my-6 flex w-full flex-row gap-2">
        <TimeBuffFilterItem value="female" onClick={handleClickFilter} selected={selectedGender === 'female'} />
        <TimeBuffFilterItem value="male" onClick={handleClickFilter} selected={selectedGender === 'male'} />
      </div>
      <Button className="w-full" style={{ text: brsc.btn_region_popup, color: 'white', fontColor: 'black' }} onClick={swipe} />
      {!TimeBuffManager.getIsTimeBuff() && <Button className="mt-2 w-full" style={{ text: brsc.later, fontColor: 'white', type: 'text' }} onClick={() => close(sheet.id)} />}
    </div>
  );
};

const TimeBuffInfo: React.FC = () => {
  const { open } = useBottomSheet();

  return (
    <div className="relative flex w-full flex-col items-center">
      <Icon name="icon/ic_guide.svg" className="absolute right-0 top-0 z-10" onClick={() => open('TimeBuffHistory')} size={36} />
      <div className="px-12 py-2 text-center">
        <img className="w-3/4" src="/imgweb/sale/infinity_silver.png" alt="" />
      </div>
      <div className="px-8 pb-2 text-center typography-headline-lg text-white">{`${brsc.time_buff}: ${brsc.count_item.replace('$param', ItemDataManager.getItemCount('timeBuff'))}`}</div>
      <div className="typography-body-sm">
        {brsc.expiration_date}:{' '}
        {ItemDataManager.getItemsByCategory('timeBuff').length > 0
          ? `${TimeUtil.getYYMMDDFromDate(ItemDataManager.getItemsByCategory('timeBuff')[0].createdTime)}~${TimeUtil.getYYMMDDFromDate(
              ItemDataManager.getItemsByCategory('timeBuff')[0].expireAt
            )}`
          : ''}
      </div>
    </div>
  );
};

interface TimeBuffFilterItemProps {
  value: string;
  onClick: (value: string) => void;
  selected: boolean;
}

const TimeBuffFilterItem: React.FC<TimeBuffFilterItemProps> = ({ value, onClick, selected }) => {
  return (
    <div
      onClick={() => onClick(value)}
      className="flex-column align-center flex flex-1 justify-center rounded-xl border-4 border-solid bg-white p-4"
      style={{ borderColor: selected ? '#FF4391' : 'white' }}
    >
      <div className="typography-headline-lg text-black">{value === 'male' ? brsc.male : brsc.female}</div>
      <div className="text3 rounded-md px-2 py-0.5 text-white" style={{ backgroundColor: '#FF4391', visibility: selected ? 'visible' : 'hidden' }}>
        FREE
      </div>
      <img className="mt-3" src={`/imgweb/sale/time_buff_${value}_${selected ? 'active' : 'inactive'}.svg`} alt="" />
    </div>
  );
};

export default TimeBuffFilters;
